import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload, faHeart as faHeartSolid, faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import {faHeart as faHeartRegular} from '@fortawesome/free-regular-svg-icons'
library.add(
    faDownload,
    faHeartRegular,
    faHeartSolid,
    faArrowLeft
);